export const HEADER_TYPE = 1;
export const FOOTER_TYPE = 2;
